

/// <reference path="CoreEntityUpdatedBy.ts" />

// Generated class AdyenCore_ManagedObject

class AdyenCore_ManagedObject extends CoreEntityUpdatedBy
{

    // Property: adyenID
    set adyenID(value:string) {
        this.setValueForKey(value, 'adyenID');
    }
    get adyenID():string {
        return this.valueForKey('adyenID');
    }
    set adyenIDPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'adyenID');
    }
    get adyenIDPrimitiveValue():string {
        return this.primitiveValueForKey('adyenID');
    }

    // Property: adyenReference
    set adyenReference(value:string) {
        this.setValueForKey(value, 'adyenReference');
    }
    get adyenReference():string {
        return this.valueForKey('adyenReference');
    }
    set adyenReferencePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'adyenReference');
    }
    get adyenReferencePrimitiveValue():string {
        return this.primitiveValueForKey('adyenReference');
    }

    // Property: status
    set status(value:number) {
        this.setValueForKey(value, 'status');
    }
    get status():number {
        return this.valueForKey('status');
    }
    set statusPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'status');
    }
    get statusPrimitiveValue():number {
        return this.primitiveValueForKey('status');
    }
}
